import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen">
            <header className="bg-gradient-to-l from-blue-900 to-[#173363] py-16 text-center text-white">
                <h1 className="text-5xl font-bold">Privacy Policy</h1>
                <p className="text-lg mt-2">Effective Date: January 09, 2025</p>
            </header>
            <main className="max-w-[140rem] mx-auto min-h-screen bg-gray-50 shadow-xl rounded-xl px-20 py-10 my-16">
                <section className="mb-10 mt-10">
                    <h2 className="text-4xl font-bold text-gray-800 mb-4 text-center">Welcome to Our Privacy Policy</h2>
                    <p className="text-xl text-gray-600 leading-relaxed mt-10">
                        SBAAA, LLC ("we," "us," or "our") is committed to protecting your privacy. This Privacy
                        Policy describes how we collect, use, and safeguard your information when you visit our
                        website (the "Site"). By accessing or using the Site, you agree to the terms of this Privacy
                        Policy. If you do not agree, please refrain from using the Site.
                    </p>
                </section>
                <section className="mb-10">
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Information We Collect</h2>
                    <ul className="list-inside text-xl text-gray-600 space-y-4">
                        <li>
                            <span className="font-semibold text-xl">Personal Information:</span> Information you provide to us directly, such as your
                            name, email address, phone number, mailing address, and any other details you submit
                            through forms on our Site.
                        </li>
                        <li>
                            <span className="font-semibold text-xl">Non-Personal Information:</span> Information automatically collected when you use
                            the Site, including your IP address, browser type, device information, and browsing behavior
                            (e.g., pages visited, time spent on the Site).
                        </li>
                        <li>
                            <span className="font-semibold text-xl">Cookies and Tracking Technologies:</span> We may use cookies and similar
                            technologies to collect information about your interactions with the Site. Cookies are small
                            text files stored on your device that help us improve the functionality and user experience of
                            the Site.
                        </li>
                    </ul>
                </section>
                <section className="mb-10">
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">2. How We Use Your Information</h2>
                    <ul className="list-disc list-inside text-xl text-gray-600 space-y-3">
                        <li>To provide, operate, and maintain the Site.</li>
                        <li>To communicate with you, respond to inquiries, and provide customer support.</li>
                        <li>To send you promotional and marketing materials (if you opt-in).</li>
                        <li>To analyze usage and improve the Site’s performance and functionality.</li>
                        <li>To ensure the security and integrity of the Site.</li>
                    </ul>
                </section>
                <section>
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Contact Information</h2>
                    <p className="text-xl text-gray-600 leading-relaxed">
                        If you have any questions or concerns about this Privacy Policy, please contact us at:
                    </p>
                    <address className="mt-20 text-xl text-gray-700 font-medium not-italic">
                        SBAAA, LLC<br />
                        Attn: Legal Department <br />
                        2080 Fairport Nine Mile Point Rd.<br />
                        Dept. 74 <br />
                        Penfield, NY 14526-9998
                    </address>
                </section>
            </main>
        </div>
    );
};

export default PrivacyPolicy;
